<template>
  <MDBRow>
    <MDBCol col="12" xl="8">
      <Slider :slides="slides" v-if="!loading" />
      <Loader :show="loading" v-if="loading" />
    </MDBCol>

    <MDBCol col="12" xl="4">
      <div class="column-order h-100" v-if="!loading">
        <div v-for="(box, index) in mainBoxes" :key="index">
          <a :href="box.url[storedLocale]" :target="box.new_tab ? '_blank' : '_self'">
            <img :src="box.image[storedLocale]" class="w-100" :alt="box.name[storedLocale]"
              :class="{ 'mt-3': index != 0 }" />
          </a>
        </div>
      </div>
      <div class="column-order h-100" v-if="loading">
        <Loader :show="loading" v-if="loading" />
      </div>
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { computed, ref, watch } from "vue";
import Slider from "./Slider.vue";
import { MDBCol, MDBRow } from "mdb-vue-ui-kit";
import Loader from "@/components/General/Loader/index";

const store = useStore();
const router = useRouter();

const slides = computed(() => store.getters.getUserSlides);
const user = computed(() => store.getters.getMe);
const storedLocale = computed(() => store.getters.getCurrentLocale);
const loading = computed(() => store.getters.getSliderIsLoading);
const isStaff = ref(false);
const isDealer = ref(false);

const mainBoxes = computed(() => store.getters.getMainBoxes);

watch(user, async (newVal) => {
  if (newVal && newVal.roles.find((item) => item.name == "staff")) {
    isStaff.value = true;
  }
  if (newVal && newVal.roles.find((item) => item.name == "dealer")) {
    isDealer.value = true;
  }

  if (newVal && (newVal.roles.find((item) => item.name == "wholesaler") || newVal.roles.find((item) => item.name == "wholesalerStaff"))) {
    router.push({ name: "wholesaler" })
  }
});
</script>

<style scoped lang="scss">
@import "../../styles/_variables.scss";
</style>
